// TestRunListSkeleton.tsx
import React from 'react'
import { Card, Divider, List, Skeleton } from 'antd'

export default function SkeletonTestRunList({ rows = 3 }) {
    // const items = Array.from({ length: rows })

    return (
        <div>
            {/* "Select all" row placeholder */}
            <div
                style={{
                    padding: '8px 0 12px 4px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                }}
            >
                {/* <Skeleton.Button
                    active
                    style={{ width: 16, height: 16, borderRadius: 4 }}
                /> */}
                <Skeleton.Input
                    active
                    size="small"
                    style={{ width: 100, height: 18 }}
                />
            </div>

            <List
                split={false}
                dataSource={[1, 2, 3]}
                renderItem={(_, i) => (
                    <List.Item style={{ padding: 0, border: 'none' }} key={i}>
                        <Card
                            size="small"
                            bodyStyle={{ padding: 16 }}
                            style={{
                                width: '100%',
                                marginBottom: 12,
                                borderRadius: 10,
                            }}
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    gap: 16,
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                }}
                            >
                                {/* Left: checkbox + avatar + texts */}
                                <div
                                    style={{
                                        display: 'flex',
                                        gap: 12,
                                        alignItems: 'flex-start',
                                        flex: 1,
                                        minWidth: 0,
                                    }}
                                >
                                    {/* Checkbox square */}
                                    {/* <Skeleton.Button
                                        active
                                        style={{
                                            width: 16,
                                            height: 16,
                                            borderRadius: 4,
                                            marginTop: 6,
                                        }}
                                    /> */}

                                    {/* Text block */}
                                    <div style={{ minWidth: 0, flex: 1 }}>
                                        {/* Title */}
                                        <Skeleton.Input
                                            active
                                            block
                                            style={{
                                                height: 20,
                                                marginBottom: 8,
                                            }}
                                        />
                                        {/* By … on …  |  Edit */}
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 8,
                                                flexWrap: 'wrap',
                                            }}
                                        >
                                            <Skeleton.Input
                                                active
                                                size="small"
                                                style={{
                                                    width: 220,
                                                    height: 16,
                                                }}
                                            />
                                            <Divider type="vertical" />
                                            <Skeleton.Input
                                                active
                                                size="small"
                                                style={{
                                                    width: 50,
                                                    height: 16,
                                                }}
                                            />
                                        </div>
                                        {/* Summary line */}
                                        <Skeleton.Input
                                            active
                                            block
                                            size="small"
                                            style={{
                                                height: 16,
                                                marginTop: 6,
                                                width: '60%',
                                            }}
                                        />
                                        {/* Due date */}
                                        <Skeleton.Input
                                            active
                                            size="small"
                                            style={{
                                                height: 16,
                                                marginTop: 6,
                                                width: 110,
                                            }}
                                        />
                                    </div>
                                </div>

                                {/* Right: progress bar + % + delete */}
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 12,
                                        width: 220,
                                    }}
                                >
                                    {/* Progress bar placeholder */}
                                    <Skeleton.Input
                                        active
                                        style={{ height: 10, width: 10 }}
                                    />
                                    {/* % */}
                                    {/* <Skeleton.Input
                                        active
                                        style={{ width: 10, height: 18 }}
                                    /> */}
                                    {/* Delete icon button */}
                                    {/* <Skeleton.Button
                                        active
                                        shape="circle"
                                        style={{ width: 28, height: 28 }}
                                    /> */}
                                </div>
                            </div>
                        </Card>
                    </List.Item>
                )}
            />
        </div>
    )
}
